import React from "react";

import type { IProjectScheduledOccupancyItem } from "@/providers/store/api/projects/projects.interface";
import { formatNumber } from "@/shared/utils/format-number.util";

import { SectionBasicInfoList } from "./section-basic-info-list";
import { SectionTitle } from "./section-title";

interface ProjectScheduledOccupancyProps {
  scheduledOccupancy: IProjectScheduledOccupancyItem[];
}

export const ProjectScheduledOccupancy: React.FC<ProjectScheduledOccupancyProps> = ({
  scheduledOccupancy,
}) => {
  return (
    <div>
      <SectionTitle title="Scheduled Occupancy" />
      <SectionBasicInfoList
        items={scheduledOccupancy.map((row) => ({
          type: "text" as const,
          head: String(row.year),
          value: `${formatNumber(row.units)} units`,
        }))}
      />
    </div>
  );
};
